import { BrokerTeamList } from '@insurance/api/requests'
import { ConditionalText, TableActions } from '@shared/components'
import { getFullName } from '@shared/utils'
import { ColumnProps } from 'antd/es/table'
import { MenuProps } from 'antd/lib'
import { TFunction } from 'i18next'

export const getTableColumns = (
  actions: (content: BrokerTeamList) => MenuProps['items'],
  t: TFunction
): ColumnProps<BrokerTeamList>[] => [
  {
    title: t('name'),
    key: 'name',
    dataIndex: 'name'
  },
  {
    title: t('agents'),
    key: 'users',
    dataIndex: 'users',
    render: (_, { users }) => (
      <ConditionalText condition={!!users.length}>
        {users.map(getFullName).join(', ')}
      </ConditionalText>
    )
  },
  {
    key: 'actions',
    align: 'center',
    width: 80,
    render: (_, row) => <TableActions options={actions(row)} />
  }
]
